<template>
  <div class="page-tab">
    <div v-for="(item, key) in currentList" class="tab-item" :class="[currentActive == key ? 'tab-item-active' : '']"
      :key="key" :title="item.title">
      <router-link :to="item.path" @click.native="clickTab(key)" tag="div">{{
        item.title
      }}</router-link>
      <div @click="clickClose(key)" class="page-tab-close"></div>
    </div>
  </div>
</template>

<script>
import i18n from '../locales/index'

import bus from "../libs/bus";
export default {
  name: "pageTab",
  data() {
    return {
      //路由库
      sourceList: [
        {
          name: "welcome",
          path: "/index/welcome",
          title: i18n.t('欢迎页'),
        },
        {
          name: "realTimeLine",
          path: `/index/realTimeLine`,
          //                path:`/index/realTimeLine${localStorage.getItem('realTimeLineInfor') ? `?id=${JSON.parse(localStorage.getItem('realTimeLineInfor')).userID}&bedID=${JSON.parse(localStorage.getItem('realTimeLineInfor')).bedID}&mac=${JSON.parse(localStorage.getItem('realTimeLineInfor')).mac}` : ''}`,
          title: i18n.t('波形图监测'),
        },
        {
          name: "realtimeMonitor",
          path: "/index/realtimeMonitor",
          title: i18n.t('实时监测'),
        },
        {
          name: "warningDeal",
          path: "/index/warningDeal",
          title: i18n.t('预警处理'),
        },
        {
          name: "cccHome",
          path: "/index/cccHome",
          title: i18n.t('话务列表'),
        },
        {
          name: "callRecord",
          path: "/index/callRecord",
          title: i18n.t('通话记录'),
        },
        {
          name: "visitManage",
          path: "/index/visitManage",
          title: i18n.t('回访管理'),
        },
        {
          name: "SleepZone",
          path: "/index/SleepZone",
          title: i18n.t('生命体征仪'),
        },
        {
          name: "userManagement",
          path: "/index/userManagement",
          title: i18n.t('会员管理'),
        },
        {
          name: "deviceList",
          path: "/index/deviceList",
          title: i18n.t('4G设备'),
        },
        {
          name: "homeDeviceManage",
          path: "/index/homeDeviceManage",
          title: i18n.t('居家安全设备'),
        },
        {
          name: "bloodPressureList",
          path: "/index/bloodPressureList",
          title: i18n.t('血压管理'),
        },
        {
          name: "serviceDispatch",
          path: "/index/serviceDispatch",
          title: i18n.t('派单中心'),
        },
        {
          name: "bigScreen",
          path: "/index/bigScreen",
          title: i18n.t('大屏数据'),
        },
        {
          name: "dataAnalyze",
          path: "/index/dataAnalyze",
          title: i18n.t('数据分析'),
        },
        {
          name: "employee",
          path: "/index/employee",
          title: i18n.t('员工列表'),
        },
        {
          name: "serviceType",
          path: "/index/serviceType",
          title: i18n.t('服务类型'),
        },
        {
          name: "serviceList",
          path: "/index/serviceList",
          title: i18n.t('服务清单'),
        },
        {
          name: "orgManage",
          path: "/index/orgManage",
          title: i18n.t('机构组织管理'),
        },
        {
          name: "warningSetting",
          path: "/index/warningSetting/sleepZoneSet",
          title: i18n.t('通用设置'),
        },
        {
          name: "personalSetting",
          path: "/index/personalSetting/sleepZonePSet",
          title: i18n.t('个性化设置'),
        },
        {
          name: "userInfo",
          path: `/index/userInfo/BasicInfo`,
          title: i18n.t('信息详情'),
        },
        {
          name: "characterMG",
          path: "/index/characterMG",
          title: i18n.t('角色管理'),
        },
        {
          name: "associatedHardware",
          path: "/index/associatedHardware",
          title: i18n.t('关联硬件系统'),
        },
        {
          name: "userDetail",
          //                path: `/index/userDetail/baseInfo?id=${.}`,
          path: `/index/userDetail/baseInfo`,
          title: i18n.t('老人详细信息'),
        },
        {
          name: "baseMG",
          //                path: `/index/userDetail/baseInfo?id=${.}`,
          path: `/index/baseMG/baseSet`,
          title: i18n.t('基础类型'),
        },
        {
          name: "reports",
          //                path: `/index/userDetail/baseInfo?id=${.}`,
          path: `/index/reports/staffReport`,
          title: i18n.t('人员报表'),
        },
        {
          name: "broadcastManage",
          //                path: `/index/userDetail/baseInfo?id=${.}`,
          path: `/index/broadcastManage`,
          title: i18n.t('广播管理'),
        },
        {
          name: "remoteMonitor",
          //                path: `/index/userDetail/baseInfo?id=${.}`,
          path: `/index/remoteMonitor`,
          title: i18n.t('远程监控'),
        },
        {
          name: "404",
          path: "/index/404",
          title: i18n.t('没找到网页'),
        },
      ],
      sourceListOne: [
        {
          name: "welcome",
          path: "/index/welcome",
          title: i18n.t('欢迎页'),
        },
        {
          name: "realTimeLine",
          path: `/index/realTimeLine`,
          //                path:`/index/realTimeLine${localStorage.getItem('realTimeLineInfor') ? `?id=${JSON.parse(localStorage.getItem('realTimeLineInfor')).userID}&bedID=${JSON.parse(localStorage.getItem('realTimeLineInfor')).bedID}&mac=${JSON.parse(localStorage.getItem('realTimeLineInfor')).mac}` : ''}`,
          title: i18n.t('波形图监测'),
        },
        {
          name: "realtimeMonitor",
          path: "/index/realtimeMonitor",
          title: i18n.t('实时监测'),
        },

        {
          name: "cccHome",
          path: "/index/cccHome",
          title: i18n.t('话务列表'),
        },
        {
          name: "callRecord",
          path: "/index/callRecord",
          title: i18n.t('通话记录'),
        },
        {
          name: "visitManage",
          path: "/index/visitManage",
          title: i18n.t('回访管理'),
        },


        {
          name: "warningDeal",
          path: "/index/warningDeal",
          title: i18n.t('预警处理'),
        },
        {
          name: "SleepZone",
          path: "/index/SleepZone",
          title: i18n.t('生命体征仪'),
        },
        {
          name: "userManagement",
          path: "/index/userManagement",
          title: i18n.t('人员管理'),
        },
        {
          name: "deviceList",
          path: "/index/deviceList",
          title: i18n.t('智能设备'),
        },
        {
          name: "homeDeviceManage",
          path: "/index/homeDeviceManage",
          title: i18n.t('居家安全设备'),
        },
        {
          name: "bloodPressureList",
          path: "/index/bloodPressureList",
          title: i18n.t('血压管理'),
        },
        {
          name: "serviceDispatch",
          path: "/index/serviceDispatch",
          title: i18n.t('派单中心'),
        },
        {
          name: "bigScreen",
          path: "/index/bigScreen",
          title: i18n.t('大屏数据'),
        },
        {
          name: "dataAnalyze",
          path: "/index/dataAnalyze",
          title: i18n.t('数据分析'),
        },
        {
          name: "employee",
          path: "/index/employee",
          title: i18n.t('员工列表'),
        },
        {
          name: "serviceType",
          path: "/index/serviceType",
          title: i18n.t('服务类型'),
        },
        {
          name: "serviceList",
          path: "/index/serviceList",
          title: i18n.t('服务清单'),
        },
        {
          name: "orgManage",
          path: "/index/orgManage",
          title: i18n.t('机构组织管理'),
        },
        {
          name: "warningSetting",
          path: "/index/warningSetting/sleepZoneSet",
          title: i18n.t('通用设置'),
        },
        {
          name: "personalSetting",
          path: "/index/personalSetting/sleepZonePSet",
          title: i18n.t('个性化设置'),
        },
        {
          name: "userInfo",
          path: `/index/userInfo/BasicInfo`,
          title: i18n.t('信息详情'),
        },
        {
          name: "characterMG",
          path: "/index/characterMG",
          title: i18n.t('角色管理'),
        },
        {
          name: "associatedHardware",
          path: "/index/associatedHardware",
          title: i18n.t('关联硬件系统'),
        },
        {
          name: "userDetail",
          //                path: `/index/userDetail/baseInfo?id=${.}`,
          path: `/index/userDetail/baseInfo`,
          title: i18n.t('老人详细信息'),
        },
        {
          name: "baseMG",
          //                path: `/index/userDetail/baseInfo?id=${.}`,
          path: `/index/baseMG/baseSet`,
          title: i18n.t('基础类型'),
        },
        {
          name: "reports",
          //                path: `/index/userDetail/baseInfo?id=${.}`,
          path: `/index/reports/staffReport`,
          title: i18n.t('人员报表'),
        },
        {
          name: "broadcastManage",
          //                path: `/index/userDetail/baseInfo?id=${.}`,
          path: `/index/broadcastManage`,
          title: i18n.t('广播管理'),
        },
        {
          name: "remoteMonitor",
          //                path: `/index/userDetail/baseInfo?id=${.}`,
          path: `/index/remoteMonitor`,
          title: i18n.t('远程监控'),
        },
        {
          name: "404",
          path: "/index/404",
          title: i18n.t('没找到网页'),
        },
      ],
      //当前view路由库
      currentList: [],
      currentActive: 0,
      //由于currentActive随数组长度变化而有bug，故使用currentName来修正currentActive
      currentName: "",
      abc: "",
      userNameId: "",
      bedNameId: "",
      switchMode: 1,

      currentTo: {},
      auth: "",
      slecetName: "",
    };
  },
  mounted() {
    let that = this;

    //获取登录并转化成字符串
    this.switchMode = localStorage.getItem("toggleM");
    this.auth = JSON.parse(localStorage.getItem("auth"));
    if (this.auth.organization.tag == "ninghua") {
      this.slecetName = i18n.t('人员');
    } else {
      this.slecetName = "";
    }
    this.$nextTick(function () {
      bus.$on("routerChange", (to, from) => {
        that.changeTab(to, from);
        that.currentTo = to;
      });
    });

    this.$nextTick(function () {
      bus.$on("aacc", function () {
        console.log("我切换了6666");
        that.currentList = [];
        that.switchMode = localStorage.getItem("toggleM");
        that.changeTab(that.currentTo, "");
      });
    });
  },
  methods: {
    changeTab(to, from) {
      console.log("地方烦", to, from);
      this.userNameId = localStorage.getItem("personUserId");
      this.bedNameId = localStorage.getItem("personBedId");
      // console.log('tab栏切换002',to);

      // console.log('personUserId', localStorage.getItem('personUserId'))
      // console.log('personBedId', localStorage.getItem('personBedId'))
      let that = this;

      let toPath = to.path,
        sourceList = that.slecetName ? that.sourceListOne : that.sourceList,
        currentList = that.currentList;

      // console.log('sourceList', sourceList)

      let toName = toPath.split("/")[2];
      console.log(toName);
      //刷新之后更改链接，更改床位管理和居家管理
      // if (this.switchMode == 1 && toName == "homeMG") {
      //     toName = "bedMG";
      // } else if (this.switchMode == 2 && toName == "bedMG") {
      //     toName = "homeMG";
      // }
      //判断当前路由是否在源路由中
      console.log(toName);
      let statusS = (() => {
        console.log(sourceList);
        for (let i = 0; i < sourceList.length; i++) {
          if (toName == sourceList[i].name) {
            return sourceList[i];
          }
        }
        return false;
      })();

      //判断当前路由是否在当前view路由中
      let statusC = (() => {
        for (let i = 0; i < currentList.length; i++) {
          if (toName == currentList[i].name) {
            let ind = i;
            return ind;
          }
        }
        return false;
      })();

      if (statusS) {
        //如果当前列表没有就添加
        if (!statusC && parseInt(statusC) != 0) {
          that.currentList.push(statusS);
          that.currentActive = that.currentList.length - 1;
          that.currentName = that.currentList[that.currentActive].name;
        } else {
          console.log(2222222222);
          //如果当前列表有就
          this.currentActive = statusC;
          let list = that.slecetName ? that.sourceListOne : that.sourceList;
          that.currentName = that.currentList[that.currentActive].name;
          for (let i = 0; i < list.length; i++) {
            if (list[i].name == "userInfo") {
              list[i].path = "/index/userInfo/BasicInfo";
              let user_id = JSON.parse(localStorage.getItem("PeopleInfo")).id;
              let userId = localStorage.getItem("personUserId");
              let bedId = localStorage.getItem("personBedId");

              list[i].path = list[i].path + "?id=" + user_id + "&bid=" + bedId;
            } else if (list[i].name == "realTimeLine") {
              list[i].path = "/index/realTimeLine";

              let sleepBandData = JSON.parse(
                localStorage.getItem("sleepBandName")
              );
              console.log(sleepBandData, 'sleepBandData')
              let uId = sleepBandData ? sleepBandData.userID : "";

              let bedId = sleepBandData ? sleepBandData.bedId : "";

              let sleepMac = sleepBandData ? sleepBandData.mac : "";

              list[i].path =
                list[i].path +
                "?userID=" +
                uId +
                "&mac=" +
                sleepMac;
            } else if (list[i].name == "userDetail") {
              list[i].path = "/index/userDetail/baseInfo";
              let sleepBandId = localStorage.getItem("personUserId");
              list[i].path = list[i].path + "?id=" + sleepBandId;
            }
          }
        }
      }
    },
    //点击tab
    clickTab(e) {
      var that = this;

      this.currentActive = e;
      let list = that.slecetName ? that.sourceListOne : that.sourceList;
      that.currentName = list[that.currentActive].name;

      console.log("点击tab");

      console.log(that.currentName);
      console.log(that.currentActive);
    },
    //关闭tab
    clickClose(ind) {
      let that = this,
        currentList = that.currentList;

      if (currentList.length > 1) {
        currentList.splice(ind, 1);
        that.currentList = currentList;

        let leng = currentList.length - 1;

        //修正
        var rLeng = that.revise();
        var realLeng = rLeng ? rLeng : leng;
        console.log("realLeng:" + realLeng);

        that.currentActive = realLeng;
        that.$router.push(currentList[realLeng]["path"]);
      } else {
        console.log("留一个呗");
      }
    },
    //修正
    revise() {
      var name = this.currentName;
      var list = this.currentList;
      var ind = 0;
      for (let i = 0; i < list.length; i++) {
        if (list[i].name == name) {
          ind = i;
        }
      }
      return ind;
    },
  },
  computed: {},
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '../libs/minxin.styl';
// .page-tab ::-webkit-scrollbar-thumb {
//     background-color: #888;
//     border-radius: 4px;
//     height: 8px; /* 设置滚动条高度 */
//   }
  ::-webkit-scrollbar {
  height:5px!important; /* 滚动条宽度 */
}
 
/* 滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f7f7f7!important; /* 轨道背景色 */
}
 
/* 滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #e1e7e7!important; /* 滑块背景色 */
}
 
.page-tab {
  // overflow-x:scroll;
  height: .5rem;
  background: #ffffff;
  display: flex;
  // border-bottom: 1px solid #e5e5e5;
  padding: 4px 10px;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.06);
  overflow-x: auto;
  white-space: nowrap;

  

  .tab-item {
    // padding: 0 0.16rem;
    height: 100%;
    font-size: .15rem;
    cursor: pointer;
    position: relative;
    min-width: 1.3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    no-wrap();

    // &:hover {
    // color: #ed6d2a;
    // }

    // &:before {
    // content: '';
    // width: 1px;
    // height: 70%;
    // background: #e5e5e5;
    // position: absolute;
    // left: 0px;
    // top: 15%;
    // }
    .page-tab-close {
      width: .1rem;
      height: .1rem;
      background: url('../assets/close2x.png') center center / 10px no-repeat;
      margin: 2px 0 0 5px;
    }
  }

  .tab-item-active {
    // background: #ed6d2a;
    color: #51545b;
    background-color: #f5f5f5;
    font-weight: 400;
    font-size: .16rem;
    padding: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pageTab.vue